<template>
  <div class="search-result generic-list-item list-item--generic">
    <div class="media relative" style="">
      <badge
        v-if="showBadge"
        class="m:hidden mobile-badge"
        :theme="badgeTheme"
        size="l"
        :icon="badgeIcon"
        >{{ translateBadgeText ? translate(badgeText) : badgeText }}</badge
      >
      <img class="" :src="imageUrl" alt="" />
    </div>
    <div class="content">
      <div class="main-result-content overflow-auto gap-s width-expand">
        <span class="result-title h4 margin-s-bottom flex-middle gap-m">
          <badge
            v-if="showBadge"
            class="m:visible"
            :theme="badgeTheme"
            :icon="badgeIcon"
            >{{ translateBadgeText ? translate(badgeText) : badgeText }}</badge
          >
          <span>{{ title }}</span>
        </span>

        <div class="result-description">
          <p>{{ text }}</p>
        </div>
        <hr v-if="hasTags" class="width-expand" />
        <div v-if="hasTags" class="tags-container flex flex-wrap gap-s">
          <badge v-for="tag in tags" :theme="tag.theme">{{ tag.name }}</badge>
        </div>
      </div>
      <div class="result-cta">
        <slot name="actions" v-bind="{ listItem: this }">
          <router-link v-slot="{ navigate }" :to="itemRoute" custom>
            <form-button theme="lead" icon-end="chevron-inline-end" @click="navigate">
              {{ translate("core.more") }}
            </form-button>
          </router-link>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GenericListItem",
  props: {
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    badgeTheme: {
      type: String,
      default: "inverse",
    },
    badgeText: {
      type: String,
      default: "",
    },
    showBadge: {
      type: Boolean,
      default: true,
    },
    badgeIcon: {
      type: [String, Boolean],
      default: false,
    },
    translateBadgeText: {
      type: Boolean,
      default: true,
    },
    imageUrl: {
      type: String,
      default: false,
    },
    tags: {
      type: [Array, Boolean],
      default: false,
    },
    itemRoute: {
      type: [Object, Boolean],
      default: false,
    },
  },
  data: function () {
    return {};
  },
  computed: {
    hasTags() {
      return Array.isArray(this.tags) && this.tags.length > 0;
    },
  },
};
</script>

<style scoped lang="scss">
.generic-list-item {
  border: 1px solid var(--c-gray-2);
  background: var(--c-bg-4);
  border-radius: var(--border-radius-s);
  display: flex;
  gap: var(--margin-l);
  height: 120px;
  flex: 100%;
  position: relative;

  @media (max-width: 767px) {
    flex-direction: column;
    flex: 0 0 auto;
    width: 250px;
    height: auto;
    gap: var(--margin-m);
  }

  .media {
    min-height: 100%;
    flex: 0 0 120px;

    padding: var(--margin-s);
    border-radius: var(--margin-s) 0 0 var(--margin-s);
    border-inline-end: 1px solid var(--c-gray-2);
    background-color: var(--c-bg);

    [dir="rtl"] & {
      border-radius: 0 var(--margin-s) var(--margin-s) 0;
    }

    img {
      object-fit: cover;
      max-height: 100%;
      max-width: 100%;
      height: 100%;
      width: 100%;
      border-radius: var(--border-radius-s);
    }

    @media (max-width: 767px) {
      height: 200px;
      flex: 0 0 200px;
      width: 100%;
      min-height: 200px;
      border-radius: var(--margin-s) var(--margin-s) 0 0;
      border-inline-end: none;
      border-bottom: 1px solid var(--c-gray-2);
    }
  }

  .mobile-badge {
    position: absolute;
    top: var(--margin-m);
    inset-inline-start: var(--margin-m);
    border-radius: var(--border-radius-s);
  }

  .content {
    padding-block: var(--margin-m);
    padding-inline-end: var(--margin-l);
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: var(--margin-xl);
    align-items: center;

    @media (max-width: 767px) {
      padding-top: 0;
      padding: var(--margin-m);
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      text-align: center;
      flex: 100%;
    }
  }

  .result-title {
    @media (max-width: 767px) {
      justify-content: center;
      text-align: center;
    }
  }

  .result-description {
    @media (max-width: 767px) {
      text-align: center;
    }
  }

  .tags-container {
    display: flex;
    flex-wrap: wrap;
    gap: var(--margin-s);

    @media (max-width: 767px) {
      justify-content: center;
    }
  }

  .result-description {
    max-width: 100%;

    p {
      text-overflow: ellipsis;
      max-height: 1.5em;
      overflow: hidden;
      white-space: nowrap;
      max-width: 800px;

      @media (max-width: 1024px) {
        max-width: 300px;
      }
    }
  }

  .result-cta {
    display: flex;
    flex-direction: column;
    gap: var(--margin-m);
    padding-block: var(--margin-m);

    @media (max-width: 767px) {
      width: 100%;

      .button {
        width: 100%;
      }
    }
  }
}
</style>
<style lang="scss">
.generic-list-item {
  .result-cta {
    .button {
      min-width: 150px;
    }
  }
}
</style>
